import { getBorderBase, getFontBase, getPrefixedVar } from '@private/payment';
import styled from 'styled-components';

import Button from 'components/Button';
import Switch from 'components/Controls/Switch';
import SwitchInput from 'components/Controls/SwitchInput';
import HighlightedText from 'components/HighlightedText';
import { COMPONENTS_NAMES } from 'theme/constants';

const prefix = ['components', COMPONENTS_NAMES.FILTERS, 'sectionItem'];

export const Container = styled.div`
  padding: 12px 20px 16px;
  border-bottom-style: solid;
  ${getBorderBase(prefix)};
`;

export const Filter = styled.div`
  display: flex;
  align-items: flex-start;
  column-gap: 10px;
`;

export const FilterElements = styled.div`
  flex: 1 1 auto;
  display: flex;
  align-items: flex-start;
  column-gap: 10px;

  & > *:nth-child(2) {
    flex: 1 1;
    min-width: 0;
  }
`;

export const BaseRemoveButton = styled(Button).attrs(() => ({
  iconSize: 18,
  size: 'sm',
}))`
  min-height: 32px;
  min-width: 32px;
`;

export const RemoveButton = styled(BaseRemoveButton).attrs(() => ({
  iconSize: 18,
  size: 'sm',
}))`
  max-width: 32px;
  padding: 3px;
`;

export const StyledHighlightedText = styled(HighlightedText)`
  display: block;
  ${getFontBase([...prefix, 'label'])};

  margin-bottom: 8px;
`;

export const StyledSwitch = styled(Switch)`
  width: 100%;
  flex-direction: row-reverse;
  justify-content: space-between;
`;

export const ConditionToggle = styled(SwitchInput)`
  margin-top: 10px;
  padding-top: 10px;
  border-top-style: solid;
  ${getBorderBase(prefix)};
`;

export const ConditionBlock = styled.div`
  margin-top: 10px;
`;

export const ConflictHint = styled.div`
  display: flex;
  align-items: flex-start;
  column-gap: 8px;
  width: 0;
  min-width: 100%;
  margin-top: 10px;
  padding: 8px 10px;
  border-style: solid;
  ${getBorderBase([...prefix, 'conflictHint'])};
  ${getFontBase([...prefix, 'conflictHint'])};

  line-height: 16px;
  overflow-wrap: anywhere;
  background: ${getPrefixedVar([...prefix, 'conflictHint'], 'bg')};

  & > svg {
    flex: 0 0 auto;
    width: 16px;
    height: 16px;
    color: ${getPrefixedVar([...prefix, 'conflictHint'], 'icon')};
  }
`;
